// source: subscriptions/subscriptions.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.kazatel.subscriptions.PromocodeUses', null, global);
goog.exportSymbol('proto.kazatel.subscriptions.PromocodesUsesRequest', null, global);
goog.exportSymbol('proto.kazatel.subscriptions.Status', null, global);
goog.exportSymbol('proto.kazatel.subscriptions.Subscription', null, global);
goog.exportSymbol('proto.kazatel.subscriptions.SubscriptionType', null, global);
goog.exportSymbol('proto.kazatel.subscriptions.SubscriptionTypesRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kazatel.subscriptions.SubscriptionType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.kazatel.subscriptions.SubscriptionType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kazatel.subscriptions.SubscriptionType.displayName = 'proto.kazatel.subscriptions.SubscriptionType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kazatel.subscriptions.SubscriptionTypesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.kazatel.subscriptions.SubscriptionTypesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kazatel.subscriptions.SubscriptionTypesRequest.displayName = 'proto.kazatel.subscriptions.SubscriptionTypesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kazatel.subscriptions.Subscription = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.kazatel.subscriptions.Subscription, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kazatel.subscriptions.Subscription.displayName = 'proto.kazatel.subscriptions.Subscription';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kazatel.subscriptions.Status = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.kazatel.subscriptions.Status, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kazatel.subscriptions.Status.displayName = 'proto.kazatel.subscriptions.Status';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kazatel.subscriptions.PromocodesUsesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.kazatel.subscriptions.PromocodesUsesRequest.repeatedFields_, null);
};
goog.inherits(proto.kazatel.subscriptions.PromocodesUsesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kazatel.subscriptions.PromocodesUsesRequest.displayName = 'proto.kazatel.subscriptions.PromocodesUsesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kazatel.subscriptions.PromocodeUses = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.kazatel.subscriptions.PromocodeUses.repeatedFields_, null);
};
goog.inherits(proto.kazatel.subscriptions.PromocodeUses, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kazatel.subscriptions.PromocodeUses.displayName = 'proto.kazatel.subscriptions.PromocodeUses';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.toObject = function(opt_includeInstance) {
  return proto.kazatel.subscriptions.SubscriptionType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kazatel.subscriptions.SubscriptionType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kazatel.subscriptions.SubscriptionType.toObject = function(includeInstance, msg) {
  var f, obj = {
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subscriptionName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    usualSolution: jspb.Message.getFieldWithDefault(msg, 3, 0),
    uniqueSolution: jspb.Message.getFieldWithDefault(msg, 4, 0),
    noAds: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    countUsers: jspb.Message.getFieldWithDefault(msg, 6, 0),
    partMonthlyContest: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    codeInterval: jspb.Message.getFieldWithDefault(msg, 8, ""),
    intervalValue: jspb.Message.getFieldWithDefault(msg, 9, 0),
    price: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    ratesId: jspb.Message.getFieldWithDefault(msg, 11, 0),
    gptQueries: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kazatel.subscriptions.SubscriptionType}
 */
proto.kazatel.subscriptions.SubscriptionType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kazatel.subscriptions.SubscriptionType;
  return proto.kazatel.subscriptions.SubscriptionType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kazatel.subscriptions.SubscriptionType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kazatel.subscriptions.SubscriptionType}
 */
proto.kazatel.subscriptions.SubscriptionType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubscriptionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUsualSolution(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUniqueSolution(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNoAds(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCountUsers(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPartMonthlyContest(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCodeInterval(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIntervalValue(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPrice(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRatesId(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGptQueries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kazatel.subscriptions.SubscriptionType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kazatel.subscriptions.SubscriptionType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kazatel.subscriptions.SubscriptionType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscriptionId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSubscriptionName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUsualSolution();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getUniqueSolution();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getNoAds();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getCountUsers();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getPartMonthlyContest();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getCodeInterval();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIntervalValue();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = message.getRatesId();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getGptQueries();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
};


/**
 * optional int32 subscription_id = 1;
 * @return {number}
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.getSubscriptionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.kazatel.subscriptions.SubscriptionType} returns this
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string subscription_name = 2;
 * @return {string}
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.getSubscriptionName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.kazatel.subscriptions.SubscriptionType} returns this
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.setSubscriptionName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 usual_solution = 3;
 * @return {number}
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.getUsualSolution = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.kazatel.subscriptions.SubscriptionType} returns this
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.setUsualSolution = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 unique_solution = 4;
 * @return {number}
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.getUniqueSolution = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.kazatel.subscriptions.SubscriptionType} returns this
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.setUniqueSolution = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool no_ads = 5;
 * @return {boolean}
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.getNoAds = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.kazatel.subscriptions.SubscriptionType} returns this
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.setNoAds = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional int32 count_users = 6;
 * @return {number}
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.getCountUsers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.kazatel.subscriptions.SubscriptionType} returns this
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.setCountUsers = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool part_monthly_contest = 7;
 * @return {boolean}
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.getPartMonthlyContest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.kazatel.subscriptions.SubscriptionType} returns this
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.setPartMonthlyContest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string code_interval = 8;
 * @return {string}
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.getCodeInterval = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.kazatel.subscriptions.SubscriptionType} returns this
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.setCodeInterval = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 interval_value = 9;
 * @return {number}
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.getIntervalValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.kazatel.subscriptions.SubscriptionType} returns this
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.setIntervalValue = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional float price = 10;
 * @return {number}
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.kazatel.subscriptions.SubscriptionType} returns this
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional int32 rates_id = 11;
 * @return {number}
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.getRatesId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.kazatel.subscriptions.SubscriptionType} returns this
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.setRatesId = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 gpt_queries = 12;
 * @return {number}
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.getGptQueries = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.kazatel.subscriptions.SubscriptionType} returns this
 */
proto.kazatel.subscriptions.SubscriptionType.prototype.setGptQueries = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kazatel.subscriptions.SubscriptionTypesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.kazatel.subscriptions.SubscriptionTypesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kazatel.subscriptions.SubscriptionTypesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kazatel.subscriptions.SubscriptionTypesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    archival: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kazatel.subscriptions.SubscriptionTypesRequest}
 */
proto.kazatel.subscriptions.SubscriptionTypesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kazatel.subscriptions.SubscriptionTypesRequest;
  return proto.kazatel.subscriptions.SubscriptionTypesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kazatel.subscriptions.SubscriptionTypesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kazatel.subscriptions.SubscriptionTypesRequest}
 */
proto.kazatel.subscriptions.SubscriptionTypesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setArchival(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kazatel.subscriptions.SubscriptionTypesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kazatel.subscriptions.SubscriptionTypesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kazatel.subscriptions.SubscriptionTypesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kazatel.subscriptions.SubscriptionTypesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {boolean} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool archival = 1;
 * @return {boolean}
 */
proto.kazatel.subscriptions.SubscriptionTypesRequest.prototype.getArchival = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.kazatel.subscriptions.SubscriptionTypesRequest} returns this
 */
proto.kazatel.subscriptions.SubscriptionTypesRequest.prototype.setArchival = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.kazatel.subscriptions.SubscriptionTypesRequest} returns this
 */
proto.kazatel.subscriptions.SubscriptionTypesRequest.prototype.clearArchival = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kazatel.subscriptions.SubscriptionTypesRequest.prototype.hasArchival = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kazatel.subscriptions.Subscription.prototype.toObject = function(opt_includeInstance) {
  return proto.kazatel.subscriptions.Subscription.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kazatel.subscriptions.Subscription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kazatel.subscriptions.Subscription.toObject = function(includeInstance, msg) {
  var f, obj = {
    subsInstanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    dateAssignment: (f = msg.getDateAssignment()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateEnd: (f = msg.getDateEnd()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    login: jspb.Message.getFieldWithDefault(msg, 4, ""),
    attrMain: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    ratesId: jspb.Message.getFieldWithDefault(msg, 6, 0),
    statusId: jspb.Message.getFieldWithDefault(msg, 7, 0),
    promocode: jspb.Message.getFieldWithDefault(msg, 8, ""),
    type: (f = msg.getType()) && proto.kazatel.subscriptions.SubscriptionType.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kazatel.subscriptions.Subscription}
 */
proto.kazatel.subscriptions.Subscription.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kazatel.subscriptions.Subscription;
  return proto.kazatel.subscriptions.Subscription.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kazatel.subscriptions.Subscription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kazatel.subscriptions.Subscription}
 */
proto.kazatel.subscriptions.Subscription.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubsInstanceId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateAssignment(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateEnd(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogin(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAttrMain(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRatesId(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatusId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPromocode(value);
      break;
    case 9:
      var value = new proto.kazatel.subscriptions.SubscriptionType;
      reader.readMessage(value,proto.kazatel.subscriptions.SubscriptionType.deserializeBinaryFromReader);
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kazatel.subscriptions.Subscription.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kazatel.subscriptions.Subscription.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kazatel.subscriptions.Subscription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kazatel.subscriptions.Subscription.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubsInstanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDateAssignment();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateEnd();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLogin();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAttrMain();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getRatesId();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getStatusId();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getType();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.kazatel.subscriptions.SubscriptionType.serializeBinaryToWriter
    );
  }
};


/**
 * optional string subs_instance_id = 1;
 * @return {string}
 */
proto.kazatel.subscriptions.Subscription.prototype.getSubsInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.kazatel.subscriptions.Subscription} returns this
 */
proto.kazatel.subscriptions.Subscription.prototype.setSubsInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp date_assignment = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.kazatel.subscriptions.Subscription.prototype.getDateAssignment = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.kazatel.subscriptions.Subscription} returns this
*/
proto.kazatel.subscriptions.Subscription.prototype.setDateAssignment = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kazatel.subscriptions.Subscription} returns this
 */
proto.kazatel.subscriptions.Subscription.prototype.clearDateAssignment = function() {
  return this.setDateAssignment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kazatel.subscriptions.Subscription.prototype.hasDateAssignment = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp date_end = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.kazatel.subscriptions.Subscription.prototype.getDateEnd = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.kazatel.subscriptions.Subscription} returns this
*/
proto.kazatel.subscriptions.Subscription.prototype.setDateEnd = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kazatel.subscriptions.Subscription} returns this
 */
proto.kazatel.subscriptions.Subscription.prototype.clearDateEnd = function() {
  return this.setDateEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kazatel.subscriptions.Subscription.prototype.hasDateEnd = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string login = 4;
 * @return {string}
 */
proto.kazatel.subscriptions.Subscription.prototype.getLogin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.kazatel.subscriptions.Subscription} returns this
 */
proto.kazatel.subscriptions.Subscription.prototype.setLogin = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool attr_main = 5;
 * @return {boolean}
 */
proto.kazatel.subscriptions.Subscription.prototype.getAttrMain = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.kazatel.subscriptions.Subscription} returns this
 */
proto.kazatel.subscriptions.Subscription.prototype.setAttrMain = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional int32 rates_id = 6;
 * @return {number}
 */
proto.kazatel.subscriptions.Subscription.prototype.getRatesId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.kazatel.subscriptions.Subscription} returns this
 */
proto.kazatel.subscriptions.Subscription.prototype.setRatesId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 status_id = 7;
 * @return {number}
 */
proto.kazatel.subscriptions.Subscription.prototype.getStatusId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.kazatel.subscriptions.Subscription} returns this
 */
proto.kazatel.subscriptions.Subscription.prototype.setStatusId = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string promocode = 8;
 * @return {string}
 */
proto.kazatel.subscriptions.Subscription.prototype.getPromocode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.kazatel.subscriptions.Subscription} returns this
 */
proto.kazatel.subscriptions.Subscription.prototype.setPromocode = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.kazatel.subscriptions.Subscription} returns this
 */
proto.kazatel.subscriptions.Subscription.prototype.clearPromocode = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kazatel.subscriptions.Subscription.prototype.hasPromocode = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional SubscriptionType type = 9;
 * @return {?proto.kazatel.subscriptions.SubscriptionType}
 */
proto.kazatel.subscriptions.Subscription.prototype.getType = function() {
  return /** @type{?proto.kazatel.subscriptions.SubscriptionType} */ (
    jspb.Message.getWrapperField(this, proto.kazatel.subscriptions.SubscriptionType, 9));
};


/**
 * @param {?proto.kazatel.subscriptions.SubscriptionType|undefined} value
 * @return {!proto.kazatel.subscriptions.Subscription} returns this
*/
proto.kazatel.subscriptions.Subscription.prototype.setType = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kazatel.subscriptions.Subscription} returns this
 */
proto.kazatel.subscriptions.Subscription.prototype.clearType = function() {
  return this.setType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kazatel.subscriptions.Subscription.prototype.hasType = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kazatel.subscriptions.Status.prototype.toObject = function(opt_includeInstance) {
  return proto.kazatel.subscriptions.Status.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kazatel.subscriptions.Status} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kazatel.subscriptions.Status.toObject = function(includeInstance, msg) {
  var f, obj = {
    statusId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    statusName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kazatel.subscriptions.Status}
 */
proto.kazatel.subscriptions.Status.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kazatel.subscriptions.Status;
  return proto.kazatel.subscriptions.Status.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kazatel.subscriptions.Status} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kazatel.subscriptions.Status}
 */
proto.kazatel.subscriptions.Status.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatusId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kazatel.subscriptions.Status.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kazatel.subscriptions.Status.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kazatel.subscriptions.Status} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kazatel.subscriptions.Status.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatusId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getStatusName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 status_id = 1;
 * @return {number}
 */
proto.kazatel.subscriptions.Status.prototype.getStatusId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.kazatel.subscriptions.Status} returns this
 */
proto.kazatel.subscriptions.Status.prototype.setStatusId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string status_name = 2;
 * @return {string}
 */
proto.kazatel.subscriptions.Status.prototype.getStatusName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.kazatel.subscriptions.Status} returns this
 */
proto.kazatel.subscriptions.Status.prototype.setStatusName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.kazatel.subscriptions.PromocodesUsesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kazatel.subscriptions.PromocodesUsesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.kazatel.subscriptions.PromocodesUsesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kazatel.subscriptions.PromocodesUsesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kazatel.subscriptions.PromocodesUsesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    promocodesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kazatel.subscriptions.PromocodesUsesRequest}
 */
proto.kazatel.subscriptions.PromocodesUsesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kazatel.subscriptions.PromocodesUsesRequest;
  return proto.kazatel.subscriptions.PromocodesUsesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kazatel.subscriptions.PromocodesUsesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kazatel.subscriptions.PromocodesUsesRequest}
 */
proto.kazatel.subscriptions.PromocodesUsesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addPromocodes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kazatel.subscriptions.PromocodesUsesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kazatel.subscriptions.PromocodesUsesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kazatel.subscriptions.PromocodesUsesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kazatel.subscriptions.PromocodesUsesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPromocodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string promocodes = 1;
 * @return {!Array<string>}
 */
proto.kazatel.subscriptions.PromocodesUsesRequest.prototype.getPromocodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.kazatel.subscriptions.PromocodesUsesRequest} returns this
 */
proto.kazatel.subscriptions.PromocodesUsesRequest.prototype.setPromocodesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.kazatel.subscriptions.PromocodesUsesRequest} returns this
 */
proto.kazatel.subscriptions.PromocodesUsesRequest.prototype.addPromocodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.kazatel.subscriptions.PromocodesUsesRequest} returns this
 */
proto.kazatel.subscriptions.PromocodesUsesRequest.prototype.clearPromocodesList = function() {
  return this.setPromocodesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.kazatel.subscriptions.PromocodeUses.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kazatel.subscriptions.PromocodeUses.prototype.toObject = function(opt_includeInstance) {
  return proto.kazatel.subscriptions.PromocodeUses.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kazatel.subscriptions.PromocodeUses} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kazatel.subscriptions.PromocodeUses.toObject = function(includeInstance, msg) {
  var f, obj = {
    promocode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    subscriptionsList: jspb.Message.toObjectList(msg.getSubscriptionsList(),
    proto.kazatel.subscriptions.Subscription.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kazatel.subscriptions.PromocodeUses}
 */
proto.kazatel.subscriptions.PromocodeUses.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kazatel.subscriptions.PromocodeUses;
  return proto.kazatel.subscriptions.PromocodeUses.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kazatel.subscriptions.PromocodeUses} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kazatel.subscriptions.PromocodeUses}
 */
proto.kazatel.subscriptions.PromocodeUses.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPromocode(value);
      break;
    case 2:
      var value = new proto.kazatel.subscriptions.Subscription;
      reader.readMessage(value,proto.kazatel.subscriptions.Subscription.deserializeBinaryFromReader);
      msg.addSubscriptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kazatel.subscriptions.PromocodeUses.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kazatel.subscriptions.PromocodeUses.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kazatel.subscriptions.PromocodeUses} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kazatel.subscriptions.PromocodeUses.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPromocode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.kazatel.subscriptions.Subscription.serializeBinaryToWriter
    );
  }
};


/**
 * optional string promocode = 1;
 * @return {string}
 */
proto.kazatel.subscriptions.PromocodeUses.prototype.getPromocode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.kazatel.subscriptions.PromocodeUses} returns this
 */
proto.kazatel.subscriptions.PromocodeUses.prototype.setPromocode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Subscription subscriptions = 2;
 * @return {!Array<!proto.kazatel.subscriptions.Subscription>}
 */
proto.kazatel.subscriptions.PromocodeUses.prototype.getSubscriptionsList = function() {
  return /** @type{!Array<!proto.kazatel.subscriptions.Subscription>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.kazatel.subscriptions.Subscription, 2));
};


/**
 * @param {!Array<!proto.kazatel.subscriptions.Subscription>} value
 * @return {!proto.kazatel.subscriptions.PromocodeUses} returns this
*/
proto.kazatel.subscriptions.PromocodeUses.prototype.setSubscriptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.kazatel.subscriptions.Subscription=} opt_value
 * @param {number=} opt_index
 * @return {!proto.kazatel.subscriptions.Subscription}
 */
proto.kazatel.subscriptions.PromocodeUses.prototype.addSubscriptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.kazatel.subscriptions.Subscription, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.kazatel.subscriptions.PromocodeUses} returns this
 */
proto.kazatel.subscriptions.PromocodeUses.prototype.clearSubscriptionsList = function() {
  return this.setSubscriptionsList([]);
};


goog.object.extend(exports, proto.kazatel.subscriptions);
